module.exports = __webpack_public_path__ + "img/code.0b243a58.jpg";